var _ = require('lodash');
module.exports = function mergeItems(existingItems, newItems) {
  var propsToCompare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['code'];
  _.each(_.castArray(newItems), function (item) {
    var comparison = {};
    _.each(_.castArray(propsToCompare), function (prop) {
      comparison[prop] = item[prop];
    });
    var existing = _.find(existingItems, comparison);
    if (existing) {
      _.extend(existing, item);
    } else {
      existingItems.push(item);
    }
  });
};